'use client';

import { PageMatter } from '@/lib/content';
import { Star, Users, Calendar, TrendingUp } from '@/lib/icons';

interface SocialProofBannerProps {
  socialProof?: PageMatter['socialProof'];
  showOnPage?: boolean; // Control when to display
}

export function SocialProofBanner({ socialProof, showOnPage = false }: SocialProofBannerProps) {
  // Only show on homepage, hub pages, and key conversion pages
  if (!showOnPage || !socialProof) return null;

  const stats = [
    {
      icon: <Star className="w-5 h-5 text-yellow-500" />,
      value: `${socialProof.averageRating}★`,
      label: `${socialProof.googleReviews} Google Reviews`,
      color: "text-yellow-600"
    },
    {
      icon: <Users className="w-5 h-5 text-blue-500" />,
      value: socialProof.totalUsers,
      label: "Loan Officers",
      color: "text-blue-600"
    },
    {
      icon: <Calendar className="w-5 h-5 text-green-500" />,
      value: `${socialProof.yearsInBusiness}`,
      label: "Years in Business",
      color: "text-green-600"
    },
    {
      icon: <TrendingUp className="w-5 h-5 text-purple-500" />,
      value: socialProof.leadsGenerated,
      label: "Leads Generated",
      color: "text-purple-600"
    }
  ];

  return (
    <div className="bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-lg p-6 mb-8">
      <div className="text-center mb-4">
        <p className="text-lg font-semibold text-gray-800 mb-2">
          Trusted by Mortgage Professionals Nationwide
        </p>
        <p className="text-sm text-gray-600">
          Join thousands of loan officers who trust LeadPops for their marketing success
        </p>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((stat, index) => (
          <div key={index} className="text-center">
            <div className="flex justify-center mb-2">
              {stat.icon}
            </div>
            <div className={`text-2xl font-bold ${stat.color}`}>
              {stat.value}
            </div>
            <div className="text-sm text-gray-600">
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}